<template>
  <div
    class="max-h-16 fixed w-full bottom-0 bg-neutral-100 border-t border-stone-300 shadow-[0px_-10px_15px_-5px_rgba(0,0,0,0.1)] hover:md:scale-105 transition-all duration-150 ease-in cursor-pointer"
    :class="{
      'md:bottom-8 md:border md:max-w-lg md:left-1/2 md:right-1/2 md:-translate-x-1/2 md:shadow-lg md:rounded-2xl': true,
      'z-50 rounded-t-2xl max-h-full': expandDetails,
      'z-10': !expandDetails,
    }"
  >
    <transition
      enter-class="translate-y-full"
      enter-active-class="opacity-0"
      leave-class="-translate-y-full"
      mode="in-out"
    >
      <div
        @click="toggleExpandDetails"
        v-if="expandDetails"
        :class="{
          'opacity-0': !expandDetails,
          'opacity-100': expandDetails,
        }"
        class="px-6 py-3 flex flex-col justify-center gap-2 translate-y-full transition-all duration-150"
      >
        <img
          class="inline-block w-4 h-4 mx-auto rotate-180"
          :src="chevronUpIcon"
          alt="chevron-up"
        />

        <div
          v-for="(item, index) in checkoutItems"
          :key="index"
          class="text-black font-medium flex justify-between pt-2"
        >
          <div class="font-normal min-w-[30%] min-[320px]:block hidden">
            {{ item.name }}
          </div>

          <div class="flex justify-between flex-1">
            <div>{{ item.label }}</div>
            <div>{{ formatNumberToCLP(item.value) }}</div>
          </div>
        </div>
      </div>
    </transition>

    <div
      @click="toggleExpandDetails"
      class="w-full px-6 py-4 border-t border-stone-300 justify-between items-center inline-flex gap-4"
      :class="{
        'md:border-t': expandDetails,
        'md:border-none': !expandDetails,
      }"
    >
      <transition enter-class="opacity-0" leave-class="opacity-0" mode="in-out">
        <div
          v-if="expandDetails"
          class="text-black text-2xl font-medium transition-all duration-150"
        >
          Total
        </div>

        <div
          v-if="!expandDetails"
          class="text-zinc-600 text-lg font-medium transition-all duration-150"
        >
          <img class="inline-block w-4 h-4 mr-2" :src="chevronUpIcon" alt="chevron-up" />
          Ver detalle
        </div>
      </transition>

      <div class="text-black text-2xl font-medium">
        {{ formatNumberToCLP(totalPrice) }}
      </div>
    </div>
  </div>
</template>

<script setup>
import chevronUpIcon from "@assets/images/icons/chevron-up.svg";
</script>
<script>
export default {
  props: {
    quotation: {
      interviewServiceId: "1" | "2" | "3" | null,
      format: "audio" | null,
      modality: "online" | "study" | "in_person" | null,
    },
  },
  data: () => {
    return {
      expandDetails: false,
    };
  },
  computed: {
    basePrice() {
      switch (this.quotation.interviewServiceId) {
        case 1: // 60 min
          return 89990;
        case 2: // 90 min
          return 144990;
        case 3: // 120 min
          return 179990;
      }
    },
    formatPrice() {
      switch (this.quotation.format) {
        case "audio":
          return 0;
        case "video":
          return 40000;
        case null:
          return 0;
      }
    },
    modalityPrice() {
      switch (this.quotation.modality) {
        case "online":
          return 0;
        case "study":
          return 20000;
        case "in_person":
          return 25000;
        case null:
          return 0;
      }
    },
    totalPrice() {
      return this.basePrice + this.formatPrice + this.modalityPrice;
    },
    durationLabel() {
      switch (this.quotation.interviewServiceId) {
        case 1:
          return "60 minutos";
        case 2:
          return "90 minutos";
        case 3:
          return "120 minutos";
      }
    },
    formatLabel() {
      switch (this.quotation.format) {
        case "audio":
          return "Audio";
        case "video":
          return "Video";
      }
    },
    modalityLabel() {
      switch (this.quotation.modality) {
        case "online":
          return "Online";
        case "study":
          return "Estudio Memoorias";
        case "in_person":
          return "A domicilio";
      }
    },
    checkoutItems() {
      const items = [];

      if (this.quotation.format !== null) {
        items.push({
          name: "Formato:",
          label: this.formatLabel,
          value: this.formatPrice,
        });
      }

      if (this.quotation.modality !== null) {
        items.push({
          name: "Lugar:",
          label: this.modalityLabel,
          value: this.modalityPrice,
        });
      }

      if (this.quotation.interviewServiceId !== null) {
        items.push({
          name: "Duración:",
          label: this.durationLabel,
          value: this.basePrice,
        });
      }

      return items;
    },
  },
  methods: {
    formatNumberToCLP(number) {
      if (isNaN(number) || !isFinite(number)) {
        return "Invalid input";
      }

      if (number === 0) {
        return "Incluido";
      }

      const formatter = new Intl.NumberFormat("es-CL", {
        style: "currency",
        currency: "CLP",
      });

      return formatter.format(number);
    },
    toggleExpandDetails() {
      this.expandDetails = !this.expandDetails;
    },
  },
};
</script>
